import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref, computed } from 'vue'
import { adminAreaSave, adminAreaUpdate, adminAreaListByParentId } from '@/api/gucangSales/administrativeRegion'
import type { FormInstance } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import { adminAreaSaveParams } from '@/typings/api/gucangSale'

const __default__ = { name: 'editModalProvince' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<adminAreaSaveParams>({})
const emit = __emit
const toggle = (row?: adminAreaSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    console.log('editForm.value: ', editForm.value)
  } else {
    editForm.value = {}
  }
}
const conuntryArr = ref<adminAreaSaveParams[]>([])
const provinceArr = ref<adminAreaSaveParams[]>([])
// const countryData = ref()
// const provinceData = ref()
const countryData = computed(() => {
  const obj = conuntryArr.value.find(
    (item: adminAreaSaveParams) => item.countryCharCode === editForm.value.countryCharCode
  )
  // 清空省、城市的请求参数
  return { parentId: obj?.id, level: 2 }
})
const provinceData = computed(() => {
  if (!countryData.value.parentId) {
    return { parentId: '', level: 3 }
  }
  const obj = provinceArr.value.find((item: adminAreaSaveParams) => item.provinceName === editForm.value.provinceName)
  return { parentId: obj?.id, level: 3 }
})
const getCountry = async () => {
  try {
    const res: any = await adminAreaListByParentId({ parentId: '-1', level: 1 })
    conuntryArr.value = res.data
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}
const handleChangeSelect = () => {
  editForm.value.provinceName = undefined
  editForm.value.cityName = undefined
  editForm.value.areaName = undefined
}

const getProvince = async () => {
  if (!countryData.value || !countryData.value.parentId) {
    return []
  }
  try {
    const res: any = await adminAreaListByParentId(countryData.value)
    provinceArr.value = res.data
    return res.data
  } catch (error) {}
}
const handleChangeProvinceSelect = () => {
  editForm.value.cityName = undefined
  editForm.value.areaName = undefined
}
const cityArr = ref<adminAreaSaveParams[]>([])

const getCity = async () => {
  if (!provinceData.value || !provinceData.value.parentId) {
    return []
  }
  try {
    const res: any = await adminAreaListByParentId(provinceData.value)
    cityArr.value = res.data
    return res.data
  } catch (error) {}
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = editForm.value
    try {
      const index = conuntryArr.value.findIndex(
        (item: adminAreaSaveParams) => item.countryCharCode === editForm.value.countryCharCode
      )
      const indexCity = cityArr.value.findIndex(
        (item: adminAreaSaveParams) => item.cityName === editForm.value.cityName
      )
      if (editForm.value.id) {
        await adminAreaUpdate({
          ...p,
          id: editForm.value.id,
          level: 4,
          name: editForm.value.areaName,
          fullName: `${conuntryArr.value[index].countryCnName}/${editForm.value.provinceName}/${editForm.value.cityName}/${editForm.value.areaName}`
        })
      } else {
        await adminAreaSave({
          ...p,
          level: 4,
          name: editForm.value.areaName,
          provinceName: editForm.value.provinceName,
          cityName: editForm.value.cityName,
          fullName: `${conuntryArr.value[index].countryCnName}/${editForm.value.provinceName}/${editForm.value.cityName}/${editForm.value.areaName}`,
          countryCnName: conuntryArr.value[index].countryCnName,
          countryEnName: conuntryArr.value[index].countryEnName,
          parentId: cityArr.value[indexCity].id
        })
      }
      toggle()
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      console.log('error: ', error)
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_CosApiSelect = _resolveComponent("CosApiSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!
  const _directive_trim = _resolveDirective("trim")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "countryCharCode",
                label: "国家中文名",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosApiSelect, {
                    api: getCountry,
                    allowClear: false,
                    "show-search": "",
                    optionFilterProp: "label",
                    value: editForm.value.countryCharCode,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.countryCharCode) = $event)),
                    fieldNames: { label: 'countryCnName', value: 'countryCharCode' },
                    onChange: handleChangeSelect
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "provinceName",
                label: "省 / 州:",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosApiSelect, {
                    api: getProvince,
                    params: countryData.value,
                    "show-search": "",
                    optionFilterProp: "label",
                    value: editForm.value.provinceName,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.provinceName) = $event)),
                    allowClear: false,
                    fieldNames: { label: 'provinceName', value: 'provinceName' },
                    immediate: false,
                    onChange: handleChangeProvinceSelect
                  }, null, 8, ["params", "value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "cityName",
                label: "城市",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosApiSelect, {
                    api: getCity,
                    params: provinceData.value,
                    "show-search": "",
                    optionFilterProp: "label",
                    allowClear: false,
                    value: editForm.value.cityName,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.cityName) = $event)),
                    fieldNames: { label: 'cityName', value: 'cityName' },
                    immediate: false
                  }, null, 8, ["params", "value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "areaName",
                label: "县区",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: editForm.value.areaName,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.areaName) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"]), [
                    [_directive_trim]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})